module.exports = __webpack_public_path__ + "img/ar.2f451056.png";